import axios from "axios";
import { get, isEmpty } from "lodash";
import configDetails from "constants/config";

const fetcher = (method, endpoint, data = null, authenticated = true, baseUrlPath = "") => {
  const url =
    baseUrlPath === ""
      ? configDetails.ADMIN.apiHost + configDetails.ADMIN.apiPath
      : configDetails[baseUrlPath].apiHost + configDetails[baseUrlPath].apiPath;
  const token = localStorage.getItem("qjumpers.adminui.auth.token") || null;
  let config = { method, url: `${url}${endpoint}`, responseType: "json" };

  if (authenticated) {
    if (!token) {
      // need to implement logout
      // keycloak.logout({ redirectUri: window.location.origin });
    }

    if (isEmpty(baseUrlPath)) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        "x-companyId": localStorage.getItem("company-id"),
        "x-companyName": encodeURI(localStorage.getItem("company-name")),
      };
      if (sessionStorage.getItem("x-jobId")) {
        config.headers["x-jobId"] = encodeURI(sessionStorage.getItem("x-jobId"));
      }
    } else {
      config.headers = { Authorization: `Bearer ${token}` };
    }
  }

  if (data) {
    config.data = data;
  }

  return axios(config)
    .then((response) => {
      // implement token refresh
      return method === "get" ? response : { response, getUrl: url };
    })
    .catch((errorResponse) => {
      const errorDetail = errorResponse.response ?? errorResponse;
      const reloadCall = errorDetail?.config.url.split("/");
      const { status, data } = errorDetail;
      const statusText = get(errorDetail, "statusText");
      let errorMessage = data?.message ?? statusText;
      if (errorMessage === undefined) {
        errorMessage = errorResponse.message;
      }
      console.log("ErrorResponse", errorResponse);
      if (status === 401) {
        // logout
      }

      if (status !== 400) {
        sessionStorage.setItem("errorItem", "true");
        sessionStorage.setItem("status", status);
        sessionStorage.setItem("errorMsg", errorMessage);
      }

      if (reloadCall?.length >= 7 && reloadCall[6] === "organisationsettings" && status === 400) {
        sessionStorage.setItem("reload", true);
      }

      const error = new Error(errorMessage);

      error.status = status;

      console.error(error);

      return Promise.resolve(error);
    });
};

export default fetcher;
